import Cookie from "extra/cookie";
import { CONSENT_COOKIE_KEY, CONSENT_MAX_AGE_SECONDS, CONSENT_STATUS } from "constants/cookie-consent";

const ALLOWED_STATUSES = Object.values( CONSENT_STATUS );

// Anything other than an explicitly saved decision means the user has not decided yet
export const getSavedConsent = () => {
	const saved = Cookie.getCookie( CONSENT_COOKIE_KEY );
	return ALLOWED_STATUSES.includes( saved ) ? saved : null;
}

export const saveConsent = status => {
	if ( !ALLOWED_STATUSES.includes( status )) return;
	Cookie.setCookie( CONSENT_COOKIE_KEY, status, CONSENT_MAX_AGE_SECONDS );
}
